import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-fullscreen",
  "use": "icon-fullscreen-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-fullscreen\"><path d=\"M7.7 9 7 8.3l-4 4V10H2v4h4v-1H3.7zM10 2v1h2.3L8 7.3l.7.7L13 3.7V6h1V2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol